import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Service for searching publications, authors, and keywords
 */
export const searchService = {
  /**
   * Search for publications, authors, or keywords
   * @param {string} query - The search query
   * @returns {Promise<Object>} Search results including publications, authors, and total count
   */
  search: async (query) => {
    try {
      const response = await apiClient.get(endpoints.search.general, {
        params: { query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching:', error);
      throw error;
    }
  },

  /**
   * Search for published manuscripts
   * @param {string} query - The search query
   * @returns {Promise<Object>} Search results for published manuscripts
   */
  searchPublishedManuscripts: async (query) => {
    try {
      const response = await apiClient.get(endpoints.search.manuscripts, {
        params: { query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching manuscripts:', error);
      throw error;
    }
  },

  /**
   * Search for published journals
   * @param {string} query - The search query
   * @returns {Promise<Object>} Search results for published journals
   */
  searchPublishedJournals: async (query) => {
    try {
      const response = await apiClient.get(endpoints.search.journals, {
        params: { query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching journals:', error);
      throw error;
    }
  }
};
